import { useActionDefinitionPreviewQuery } from '@shared/generated/graphql';
import { actionDefinitionPreviewFromFragment } from '@shared/graphql/fromFragments/actionDefinition';
import { ActionDefinitionPreview } from '@shared/types/action-definition';

type UseActionDefinitionPreviewOptions = {
  id: string;
};

type UseActionDefinitionPreviewValue = {
  actionDefinition: ActionDefinitionPreview | null;
  isLoading: boolean;
};

export const useActionDefinitionPreview = (
  props: UseActionDefinitionPreviewOptions
): UseActionDefinitionPreviewValue => {
  const { id } = props;
  const { data, loading } = useActionDefinitionPreviewQuery({
    variables: { id },
  });

  const actionDefinition = data?.actionDefinitionById
    ? actionDefinitionPreviewFromFragment(data.actionDefinitionById)
    : null;

  return {
    actionDefinition: actionDefinition ?? null,
    isLoading: loading,
  };
};
